import { StrictDict } from '../../../utils';

import app from './app';
import video from './video';
import problem from './problem';
import game from './game';
import inVideoQuiz from './inVideoQuiz';

export default StrictDict({
  app,
  video,
  problem,
  game,
  inVideoQuiz,
});
